<template>
    <div>
        <v-card @click="way='syndicate'" :class="[way=='syndicate'?'primary':'']"  style="padding:10px;float:left;margin-right:10px;margin-bottom:10px;"  width="150px">
            <v-img :src="require('../assets/syndicate.png')" style="height:60px;background:white;"></v-img>
        </v-card>
        <v-card  @click="way='bob'" :class="[way=='bob'?'primary':'']"  style="padding:10px;float:left;margin-right:10px;margin-bottom:10px;" width="150px">
            <v-img :src="require('../assets/bob.png')" style="height:60px;background:white;" contain></v-img>
        </v-card>
        <v-card   @click="way='canera'" :class="[way=='canera'?'primary':'']"  style="padding:10px;float:left;margin-right:10px;margin-bottom:10px;" width="150px">
            <v-img :src="require('../assets/canera.jpg')" style="height:60px;background:white;" contain></v-img>
        </v-card>
        <v-card   @click="way='icici'" :class="[way=='icici'?'primary':'']"  style="padding:10px;float:left;margin-right:10px;margin-bottom:10px;" width="150px">
            <v-img :src="require('../assets/icici.png')" style="height:60px;background:white;" contain></v-img>
        </v-card>
        <v-card   @click="way='sbi'" :class="[way=='sbi'?'primary':'']"  style="padding:10px;float:left;margin-right:10px;margin-bottom:10px;" width="150px">
            <v-img :src="require('../assets/sbi.jpg')" style="height:60px;background:white;" contain></v-img>
        </v-card>
        <v-card    @click="way='iob'" :class="[way=='iob'?'primary':'']" style="padding:10px;float:left;margin-right:10px;margin-bottom:10px;" width="150px">
            <v-img :src="require('../assets/iob.jpg')" style="height:60px;background:white;" contain></v-img>
        </v-card>
        <v-card   @click="way='dub'" :class="[way=='dub'?'primary':'']"  style="padding:10px;float:left;margin-right:10px;margin-bottom:10px;" width="150px">
            <v-img :src="require('../assets/dub.png')" style="height:60px;background:white;" contain></v-img>
        </v-card>
        <v-card   @click="way='hdfc'" :class="[way=='hdfc'?'primary':'']"  style="padding:10px;float:left;margin-right:10px;margin-bottom:10px;" width="150px">
            <v-img :src="require('../assets/hdfc.webp')" style="height:60px;background:white;" contain></v-img>
        </v-card>
        <v-card   @click="way='ib'" :class="[way=='ib'?'primary':'']"  style="padding:10px;float:left;margin-right:10px;margin-bottom:10px;" width="150px">
            <v-img :src="require('../assets/ib.png')" style="height:60px;background:white;" contain></v-img>
        </v-card>
        <div style="width:100%;float:left">
            <div style="width:350px;margin:0 auto;">
            <v-btn color="primary"  style="width:100%" @click="submit">Pay Now</v-btn>

            </div >
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            way:''
        }
    },
    methods:{
        notification(type,message){
            this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000, 
                type:type               
            })
        },
        submit(){
            this.notification("","Currently Not Available!")
        }
    }
}
</script>
